import { render, staticRenderFns } from "./postDetails.vue?vue&type=template&id=e67cd4be&scoped=true&"
import script from "./postDetails.vue?vue&type=script&lang=js&"
export * from "./postDetails.vue?vue&type=script&lang=js&"
import style0 from "./postDetails.vue?vue&type=style&index=0&id=e67cd4be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e67cd4be",
  null
  
)

export default component.exports